export default __webpack_public_path__ + "static/logo-cinetimes-a4ffe88a7441d13fa860a65b22815ff2.png";